import { formatUnixTime } from "@/lib/format/time";
import StmtTypeList from "@/views/statement/components/stmtTypeList";
import StmtOptBar from "@/views/statement/components/stmtOptBar";
import StmtDetailPane from "@/views/statement/components/stmtDetailPane";
import { throttle } from "@/views/zhiji/js/common/util.js";
import { STMT_TABLE_CONFIG } from "@/views/statement/config.js";

export default {
    name: "StatementManagePane",
    props: [],
    components: {
        StmtTypeList,
        StmtOptBar,
        StmtDetailPane
    },
    data() {
        return {
            page: 0,
            pageSize: STMT_TABLE_CONFIG.pageSize,
            repository: null,
            keyword: ""
        };
    },
    computed: {
        tableData() {
            return this.getStoreProp("stmtList");
        },
        total() {
            return this.getStoreProp("total");
        }
    },
    mounted() {
        this.queryStmtList();
        this.handleSearch = throttle(() => this.queryStmtList(), 50, 200);
    },
    watch: {
        page: {
            handler() {
                this.queryStmtList();
            },
            deep: true
        },
        pageSize: {
            handler() {
                this.queryStmtList();
            },
            deep: true
        }
    },
    methods: {
        formatUnixTime,
        renderLanguage(language) {
            return language === "all" ? this.$t(`zhiji.common.allLanguage`) : this.$t(`zhiji.common.${language}`);
        },
        getStoreProp(propName) {
            return this.$store.state.statement.statement[propName];
        },
        handleRepositorySelect(repository) {
            this.repository = repository;
            this.resetParams();
            this.queryStmtList();
        },
        handleTypeSelect(type) {
            this.typeId = type;
            this.queryStmtList();
        },
        handleStmtSearch(keyword) {
            this.keyword = keyword;
            this.resetParams();
            this.queryStmtList();
        },
        handleDelete(stmtData) {
            this.$confirm(`${this.$t("statement.confirmDelete")}“${stmtData.content}”?`).then(() => {
                this.$store.dispatch("statement/deleteStmt", stmtData.id).then(() => {
                    this.$message({ message: this.$t("statement.deleteSuccess"), type: "success" });
                });
            });
        },
        resetParams() {
            this.page = 1;
        },
        queryStmtList() {
            let params = {
                page: this.page - 1,
                perpage: this.pageSize,
                keyword: this.keyword,
                repository: this.repository ? this.repository : null,
                type_id: this.$store.state.statement.statementType.selectedType
            };
            this.$store.dispatch("statement/queryStmtList", params);
        }
    }
};
